import { useEffect } from "react";
import { playbackTracker } from "../utils/playback";

interface UseVisibilityChange {
  videoRef: React.RefObject<HTMLVideoElement | null>;
  setPaused: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useVisibilityChange = ({ videoRef, setPaused }: UseVisibilityChange) => {
  useEffect(() => {
    const handler = () => {
      if (document.hidden) {
        if (videoRef.current) {
          videoRef.current.pause();
          setPaused(true);
          playbackTracker.stop();
        }
      }
    };

    document.addEventListener("visibilitychange", handler);

    return () => {
      document.removeEventListener("visibilitychange", handler);
    };
  }, [videoRef, setPaused]);

  useEffect(() => {
    const listener = () => {
      playbackTracker.stop();
    };

    window.addEventListener("beforeunload", listener);

    return () => {
      window.removeEventListener("beforeunload", listener);
    };
  }, []);
};
